import * as React from 'react';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

const ValidationSummaryContainer = styled.div`
    padding: 1rem;
    border-left: 5px solid ${tokens.error.default};
    background-color: color-mix(in srgb, ${tokens.error.default} 10%, transparent);
`;

export type ValidationSummaryProps = {
    children?: React.ReactNode;
    className?: string;
};

export function ValidationSummary({ children, className }: ValidationSummaryProps) {
    return (
        <ValidationSummaryContainer role="alert" className={className}>
            {children}
        </ValidationSummaryContainer>
    );
}
